import { defineComponent as p, openBlock as s, createElementBlock as a, renderSlot as d, Fragment as i, renderList as r, createBlock as u, withCtx as m, createElementVNode as _, toDisplayString as B } from "vue";
import S from "./index57.js";
import g from "./index58.js";
const h = {
  class: "table-body",
  "data-name": "Table/Body"
}, w = { class: "table-body-text" }, v = /* @__PURE__ */ p({
  __name: "BaseTableBody",
  props: {
    headers: {},
    data: {},
    selectable: { type: Boolean, default: !1 },
    selectedRows: { default: () => [] }
  },
  emits: ["rowSelect"],
  setup(n, { emit: y }) {
    const o = n, b = y, f = (e) => {
      if (!o.selectable) return;
      const c = o.selectedRows.includes(e);
      b("rowSelect", e, !c);
    }, k = (e) => o.selectedRows.includes(e);
    return (e, c) => (s(), a("tbody", h, [
      d(e.$slots, "body", {}, () => [
        (s(!0), a(i, null, r(n.data, (l) => (s(), u(g, {
          key: l.id,
          type: "body",
          selected: k(l.id),
          selectable: n.selectable,
          onClick: (t) => f(l.id)
        }, {
          default: m(() => [
            (s(!0), a(i, null, r(n.headers, (t) => (s(), u(S, {
              key: t.key,
              type: "body",
              align: t.align,
              width: t.width
            }, {
              default: m(() => [
                d(e.$slots, "body-cell", {
                  row: l,
                  header: t,
                  value: l[t.key]
                }, () => [
                  _("span", w, B(l[t.key] || ""), 1)
                ])
              ]),
              _: 2
            }, 1032, ["align", "width"]))), 128))
          ]),
          _: 2
        }, 1032, ["selected", "selectable", "onClick"]))), 128))
      ])
    ]));
  }
});
export {
  v as default
};
